import { Collection, Model } from 'web-mojo';
import { LocationList } from './Location.js';

class Device extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/camaccess/device'
        });
    }

    nameOrId() {
        return this.get('name') || this.get('uuid');
    }
}

class DeviceList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: Device,
            endpoint: '/api/camaccess/device',
            ...options
        });
    }
}

const DeviceForms = {
    edit: {
        title: 'Edit Device',
        fields: [
            { name: 'name', type: 'text', label: 'Name', columns: 12 },
            {
                type: 'collection', name: 'location', label: 'Location', columns: 12,
                Collection: LocationList, labelField: 'name', valueField: 'id',
                maxItems: 10, placeholder: 'Search locations...', emptyFetch: false, debounceMs: 300,
            },
        ]
    }
};

Device.EDIT_FORM = DeviceForms.edit;

export { Device, DeviceList, DeviceForms };
